<template>
  <AppModal ref="modal" :stacked="true" @close="$emit('close')" @clickaway="close">
    <template slot="modal-header">
      <h3 class="font-weight-medium">
        Edit Workflow Email
      </h3>
    </template>
    <template slot="modal-body">
      <AppLoading v-if="isLoading" class="h-50 p-4" />
      <form v-else class="form">
        <div class="mb-3">
          <label>Workflow</label>
          <Multiselect
            :value="local.approvalWorkflowId || editing.approvalWorkflowId"
            placeholder="Select Workflow"
            :options="workflowIdsByProduct"
            :customLabel="approvalCustomLabel"
            :multiple="false"
            :searchable="false"
            @input="write('approvalWorkflowId', $event)"
          />
        </div>
        <div class="mb-3">
          <label>Action</label>
          <Multiselect
            :value="local.action || editing.action"
            placeholder="Select Workflow Action"
            :options="workflowActions"
            :customLabel="decamelize"
            :multiple="false"
            :searchable="false"
            @input="write('action', $event)"
          />
        </div>
        <div class="mb-3">
          <label>Template</label>
          <Multiselect
            :value="local.emailTemplateId || editing.emailTemplateId"
            placeholder="Select Email template"
            :options="emailTemplateOptions"
            :customLabel="emailCustomLabel"
            :multiple="false"
            :searchable="false"
            @input="write('emailTemplateId', $event)"
          />
        </div>
      </form>
    </template>
    <template slot="modal-footer">
      <AppButton class="btn btn-dark" @click="close">Cancel</AppButton>
      <AppButton class="btn btn-primary btn-raised" @click="update">
        Update
      </AppButton>
    </template>
  </AppModal>
</template>

<script>
import Multiselect from '@/components/Multiselect'
import { mapGetters, mapState } from 'vuex'
import useWorkflows from '@/components/composables/useWorkflows'

export default {
  components: {
    Multiselect,
  },
  props: {
    editing: {
      type: Object,
      required: true,
    },
    workflowActions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data () {
    return { isLoading: false, local: {} }
  },
  setup () {
    const { workflowIdsByProduct } = useWorkflows({ product: 'cm' })

    return {
      workflowIdsByProduct,
    }
  },
  computed: {
    ...mapGetters([ 'approvalWorkflows', 'approvalWorkflow' ]),
    ...mapState('curriculumEmails', [ 'templates' ]),
    emailTemplateOptions () {
      return this.templates.map(template => template.id)
    },
  },
  methods: {
    write (key, val) {
      this.$set(this.local, key, val)
    },
    approvalCustomLabel (id) {
      const workflow = this.approvalWorkflow(id)
      return workflow ? workflow.name : 'Workflow Not Found'
    },
    emailCustomLabel (id) {
      const index = this.templates.findIndex(t => t.id === id)
      return this.templates[index].subject
    },
    close () {
      this.$refs.modal.close()
    },
    update () {
      this.isLoading = true
      setTimeout(() => {
        this.$emit('update', { ...this.editing, ...this.local })
        this.close()
        this.isLoading = false
      }, 1000)
    },
  },
}
</script>

<style scoped>
.modal-backdrop >>> .modal-body {
  overflow: unset;
  max-height: 100%;
}
</style>
